import React from 'react';
import Table from '../../component/table/table'
import {BASE_END_POINT} from '../../urls'
import axios from 'axios'
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import Pagination from '@material-ui/lab/Pagination';
import { MDBContainer,  MDBRow, MDBCol} from "mdbreact";
import './campaign.css'
import {message,TreeSelect} from 'antd';
import allStrings from '../../assets/strings'
import { connect } from 'react-redux';
import {SearchOutlined} from '@ant-design/icons';
import {NavLink, withRouter,Redirect} from 'react-router-dom'
import {ChangeLanguage} from '../../redux/actions/LanguageAction'
import { CSVLink } from "react-csv";
const { TreeNode } = TreeSelect;

let headers = [
  { label: "#", key: "id" },
  { label: "Name", key: "name" },
  { label: "Project", key: "project" },
  { label: "Brokers Count", key: "brokersCount" },
  { label: "Leads Count", key: "leadsCount" }
];
 
let csvData = [
  
];
class campaign extends React.Component {
  
  state={
    campaign:[],
    campaign2:[],
    loading:true,
    refresh:false,
    search:null,
    project:null,
    page:1,
    pages:1,
    csvData:[],
    projects:[]
  }

  constructor(props){
    super(props)
    this.csvLinkEl = React.createRef();
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    }
  }

  componentDidMount(){
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    } 
    this.getCampaigns(1)
    this.getCampaignsWithoutPagenation()
    this.getProjects()
  }
  getProjects = () => {
    axios.get(`${BASE_END_POINT}projects/shortList/get?all=true`,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    }).then(response=>{
      console.log(response.data)
      this.setState({projects:response.data.data})
    })
    .catch(error=>{
      console.log("ALL projects ERROR")
      console.log(error.response)
    })
  }

  getCampaigns = (page,rest) =>{
    this.setState({loading:true})
    let url =`${BASE_END_POINT}campaigns?page=${page}`
    let {search,project} = this.state
    if(search !== null){
      let str = '&search='+ search
      url += str
    }
    if(project){
      let str = '&project='+ project
      url += str
    }
    if(rest) url = `${BASE_END_POINT}campaigns?page=${page}`

    axios.get(url,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`
      }
    })
    .then(response=>{
      console.log("campaign   ",response.data)
      var data = response.data.data.map(item=>[
        item.id,
        this.props.isRTL?item.name_ar:item.name_en,
        item.img?{type:"img",img:item.img}:{type:"img",img:""},
        item.project?item.project.name:'',
        item.brokersCount,
        item.leadsCount,
        "action"])
      console.log("DATA   ",data)
      this.setState({
        loading:false,
        refresh:false,
        campaign:response.data.data,
        campaign2:data,
        page:response.data.page,
        pages:response.data.pageCount,
      })
    })
    .catch(error=>{
      console.log("error   ",error.response)
      console.log("error2   ",error)
      this.setState({loading:false,})
    })
  }
  getCampaignsWithoutPagenation = (rest) =>{
    let url = `${BASE_END_POINT}campaigns/withoutPagenation/get?page=1`
    let {search} = this.state
    if(search !== null){
      let str = '&search='+ search
      url += str
    }
    if(rest) url = `${BASE_END_POINT}campaigns/withoutPagenation/get`
    axios.get(url,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    })
    .then(response=>{
      console.log("deals   ",response.data)
        csvData= response.data.data.map(item => {
          return {
            ...{id:item.id},
            ...{name:item.name},
            ...{project:item.project?item.project.name:''},
            ...{brokersCount:item.brokersCount},
            ...{leadsCount:item.leadsCount}

          };
        });
        this.setState({csvData:csvData})
      
    })
    .catch(error=>{
      console.log("error   ",error.response)
      console.log("error2   ",error)
    })
  }
  delete = (id) => {
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}campaigns/${id}`,{
     headers: {
       'Content-Type': 'application/json',
       'Authorization':`Bearer ${this.props.currentUser.token}`
     },
    })
    .then(response=>{
      l.then(() => message.success(allStrings.done, 2.5) )
      this.getCampaigns(this.state.page,true)
    })
    .catch(error=>{
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
    })
 }

  addNewRecordButton = () =>(
    <div style={{width:'100%'}}>
      <NavLink to="AddCampaign">
        <Fab
          style={{background:'linear-gradient(135deg, #0F1A2C, #233B5B, #3A5278)',float:'left',margin:'50px 30px'}}
          variant="extended"
          size="medium"
          color="primary"
          aria-label="add"
        >
          <AddIcon />{allStrings.addNewRecored}
        </Fab>
      </NavLink>
    </div>
  )

  paginationButtons = () =>(
    <CardActions style={{display: 'inline-flex'}}>
        <Button 
        onClick={()=>{
          if(this.state.page!==1){
            this.getCampaigns(1)
            this.setState({page:1})
          }
        }}
        className="pagenation" >{allStrings.first}</Button>

        <Button 
        onClick={()=>{
         if(this.state.page>1){
            this.getCampaigns(this.state.page-1)
            this.setState({page:this.state.page-1})
         }
        }}
        className="pagenation">{allStrings.prev}</Button>
        
        <Pagination
        onChange={(event,page)=>{
        console.log("page   ",page)
        if(page!==this.state.page){
          this.getCampaigns(page)
          this.setState({page:page})
        }
        
        }} 
        defaultPage={1} page={this.state.page} count={this.state.pages} style={{color:`#233b5b !important`}} />
        
        <Button 
        onClick={()=>{
          if(this.state.page<this.state.pages){
            this.getCampaigns(this.state.page+1)
            this.setState({page:this.state.page+1})
          }
        }}
        className="pagenation">{allStrings.next}</Button>

        <Button 
         onClick={()=>{
          if(this.state.page!==this.state.pages){
            this.getCampaigns(this.state.pages)
            this.setState({page:this.state.pages})
          }
        }}
        className="pagenation">{allStrings.last}</Button>

    </CardActions>
  )

  render(){
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('CAMPAIGNS')) return <Redirect to='/Home' />

  return (
    <div className="App">
        
      <MDBContainer> 
      <MDBRow>
        <MDBCol md="12">
          <div className="screenTable">
          <Table
            title={allStrings.campaigns}
            icon='campaign'
            settings = {
              <div>
                <i class="fab fa-searchengin searchIcon" onClick={()=>this.setState({showFilter:!this.state.showFilter})}></i>
                <span 
                style={{position: 'relative',padding: '4px',color: '#659FF1',fontSize: '25px',borderRadius:'50%',top:'4px',cursor: 'pointer'}}
                onClick={() => {this.setState({search:null,status:null});this.getCampaigns(1,true);this.getCampaignsWithoutPagenation(true)}}
                class="material-icons">
                  replay
                </span>
                <CSVLink 
                  data={this.state.csvData} 
                  headers={headers} 
                  filename={"campaigns.csv"}
                  style={{padding: '10px',position: 'relative',top: '-5px'}}
                  >
                  <img crossorigin="anonymous"alt="" src={require('../../assets/images/export-csv.png')} width="28"></img>
                </CSVLink>
              </div>
              
            }
            filter ={
              <div>
                <div className={this.state.showFilter?'showClass160':'hideClass'}>
                  <MDBRow>
                    <MDBCol xl="6" lg="6" md="6" sm="12">
                      <div class="md-form">
                      <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.Search}</label>
                      <input style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center',fontWeight:'300'}} type="text" id="form605"  class="form-control"
                        placeholder={allStrings.Search}
                        onChange={(e)=>{
                          this.setState({search:e.target.value})
                        }}  
                      />
                      </div>
                    </MDBCol>
                    <MDBCol xl="6" lg="6" md="6" sm="12">
                      <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.project}</label>
                      <TreeSelect virtual={false}
                          showSearch={false}
                          style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                          treeCheckable = {false}         
                          treeNodeFilterProp="title"                      
                          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                          placeholder={allStrings.project}
                          value={this.state.project}
                          onChange={(value) => {
                            console.log(value)
                            this.setState({project:value});
                          }} 
                      
                      >
                          {this.state.projects.map(val=>(
                              <TreeNode value={val.id} title={this.props.isRTL?val.name_ar:val.name_en} key={val.id} />
                          ))}
                      </TreeSelect>
                    </MDBCol>
                    
                  </MDBRow>
                  <MDBRow>
                  <Button style={{background: '#233b5b',color: '#fff',width: '100%',margin: '32px auto'}} 
                        onClick={()=>{this.getCampaigns(1,false);this.getCampaignsWithoutPagenation()}}><SearchOutlined /> {allStrings.Search}</Button>
                  </MDBRow>
                  
                </div>
              </div>
            }
            data={this.state.campaign}
            data2={this.state.campaign2}
            tableColumns={["#",allStrings.name,allStrings.img,allStrings.project,allStrings.brokersCount,allStrings.leadsCount,allStrings.action]}
            loading={this.state.loading}
            deleteUser={(id)=>{this.delete(id)}}
            path='/campaignInfo'
            actionIndex={3}
            />
            {this.paginationButtons()}
            {this.addNewRecordButton()}
            </div>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
    </div> 
  )
  }
}

const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
})

const mapDispatchToProps = {
  ChangeLanguage
}

export default  withRouter(
  connect(mapToStateProps,mapDispatchToProps)(campaign)
);

